import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=4ad3e634&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad3e634",
  null
  
)

export default component.exports